var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex flex-col expedited-button" }, [
    _c("h3", { staticClass: "option" }, [_vm._v("\n    Expedited\n  ")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex flex-row expedited-switch" },
      [
        _c("el-switch", {
          attrs: { width: 30 },
          on: { change: _vm.toggleExpedited },
          model: {
            value: _vm.isExpedited,
            callback: function ($$v) {
              _vm.isExpedited = $$v
            },
            expression: "isExpedited",
          },
        }),
        _vm._v(" "),
        _vm.isExpedited
          ? _c("span", { staticClass: "on" }, [_vm._v("On\n    ")])
          : _c("span", { staticClass: "off" }, [_vm._v("Off\n    ")]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Choose this option to speed up the shipment."),
      _c("br"),
      _vm._v("Note that some products may have restrictions."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }